import { el, editable, input } from './domUtils';

export default class FactBoxTool {
  static get toolbox() {
    return {
      title: 'Билиб қўйинг',
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 16v-4M12 8h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M9 3h6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    };
  }

  static get sanitize() {
    return { icon: {}, heading: {}, text: {} };
  }

  constructor({ data }) {
    this.data = { icon: data.icon || 'info', heading: data.heading || '', text: data.text || '' };
  }

  render() {
    this.iconEl = el('select', { class: 'at-input at-select' }, [
      el('option', { value: 'info' }, ['Маълумот']),
      el('option', { value: 'warning' }, ['Огоҳлантириш']),
    ]);
    this.iconEl.value = this.data.icon;
    this.headingEl = input(this.data.heading, 'Сарлавҳа...');
    this.headingEl.classList.add('at-input-strong');
    this.textEl = editable(this.data.text, 'Матн...');
    return el('div', { class: 'at-block at-fact-box' }, [
      el('div', { class: 'at-block-label' }, ['Билиб қўйинг']),
      el('div', { class: 'at-row' }, [this.iconEl, this.headingEl]),
      this.textEl,
    ]);
  }

  save() {
    return {
      icon: this.iconEl.value,
      heading: this.headingEl.value.trim(),
      text: this.textEl.innerHTML.trim(),
    };
  }
}
